"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Term = void 0;

var lodash_1 = __importDefault(require("lodash"));

var Token_1 = require("./Token");

var Term = function () {
  function Term(label, token, value, opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.label = label;
    this.token = token;
    this.value = value;
    this.opts = opts;
  }

  Term.prototype.evaluate = function (tokens, configuration) {
    var _this = this;

    var evaluate = this.opts.evaluate;

    if (!evaluate) {
      console.warn("Evaluate() called on Term '" + this.token + "' that does not have an evaluate function");
      return;
    }

    try {
      var keys = lodash_1["default"].keys(configuration).filter(function (key) {
        return !lodash_1["default"].isNil(configuration[key]);
      });
      var ids = keys.concat(lodash_1["default"].values(configuration));
      var index = lodash_1["default"].findIndex(tokens, function (t) {
        return t instanceof Token_1.Token && t.token === _this.token;
      });
      return evaluate(tokens, index, ids);
    } catch (e) {
      console.error("Evaluate() called on Term '" + this.token + "' failed with error", tokens, e);
    }
  };

  Term.prototype.is = function (json) {
    try {
      return json.token === this.token;
    } catch (e) {
      return false;
    }
  };

  Term.prototype.log = function (info) {
    if (info === void 0) {
      info = {};
    }

    if (this.opts.log) {
      return this.opts.log(info);
    }

    return __assign({
      action: this.token
    }, info);
  };

  Term.prototype.override = function (tokens) {
    if (this.opts.override) {
      return this.opts.override(tokens);
    }
  };

  return Term;
}();

exports.Term = Term;